import { render, staticRenderFns } from "./StatisticByLogist.vue?vue&type=template&id=026d6288&scoped=true&"
import script from "./StatisticByLogist.vue?vue&type=script&lang=js&"
export * from "./StatisticByLogist.vue?vue&type=script&lang=js&"
import style0 from "./StatisticByLogist.vue?vue&type=style&index=0&id=026d6288&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d6288",
  null
  
)

export default component.exports